import React from "react"
import { Link, graphql, withPrefix } from "gatsby"
import styles from "../@one-builder/gatsby-theme-ob-master/styles/global.module.scss"
import Layout from "@one-builder/gatsby-theme-ob-master/src/components/layout/layout"
import setSeoData from "@one-builder/gatsby-theme-ob-master/src/helpers/setSeoData"
import FeedbackForm from "@one-builder/gatsby-theme-ob-master/src/components/feedback-form"

export default ({ data, location }) => {
  return (
    <Layout location={location}>
      <div className={styles.container}>
        <h1>Give us Your Feedback</h1>
        <p>Once a month at end of month, people who have left a feedback on the website for the current month or month prior and haven't yet won anything will be entered into a drawing for a chance to win their choice of a $100 Gift Card (Visa, Lowes, Home Depot) or 2 Hours of No-Charge Labor. Prizes are transferable. Drawing will take place on Facebook Live and the winner announced on FB as well as email to redeem his or her prize.</p>
        <FeedbackForm />
      </div>
    </Layout>
  )
}
